export enum ProductTypesEnum {
  RIM20 = 'RIM20',
  TFA = 'TFA',
  TVA = 'TVA',
  VIM20 = 'VIM20',
  ELM = 'ELM',
  UTM10 = 'UTM10'
}
